<template>
  <van-popup v-model="visible" position="top" :style="{ top: '46px' }" @close="handleClose">
    <div class="hot-wrpa" :style="list.length < 2 ? 'justify-content:flex-start;' : ''">
      <div
        v-for="(item, index) in list"
        :key="index"
        :class="{ ac: active === index }"
        class="item"
        @click="handleBreed(item, index)"
      >
        {{ item.breedName }}
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'HotChartsPopup',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    selectedBreed: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      visible: false,
      active: null,
    };
  },
  watch: {
    selectedBreed: {
      handler(newVal) {
        if (newVal && this.list.length > 0) {
          const index = this.list.findIndex((item) => item.breedId === newVal.breedId);
          if (index !== -1) {
            this.active = index;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    handleClose() {
      this.visible = false;
    },
    selectHandleBreed(list, id) {
      const index = list.findIndex((obj) => obj.breedId === id);
      this.active = index;
      const item = list[index];
      this.$emit('handleBreed', item);
    },
    handleBreed(item, index) {
      this.active = index;
      this.visible = false;
      this.$emit('handleBreed', item);
    },
  },
};
</script>

<style lang="less" scoped>
.hot-wrpa {
  background: #fff;
  z-index: 10;
  border-radius: 5px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  min-height: 75px;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  .item {
    width: 42%;
    height: 45px;
    display: flex;
    align-items: center;
    font-size: 12px;
    border-radius: 5px;
    background: #f5f5f5;
    padding: 2.5px 8px;
    box-sizing: border-box;
    margin-bottom: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    justify-content: center;
    cursor: pointer;

    &.ac {
      color: #fff;
      background: linear-gradient(to right, #f1321f, #ea8938);
    }
  }
}
</style>
